/**
 * Privacy and data hub screen (legal links + danger zone).
 */

import { LEGAL_ROOT_SLUGS } from '../landing/constants/legalRouteSlugs.constants'

export interface LegalRow {
  key: string
  slug: string
}

export const LEGAL_ROWS: LegalRow[] = [
  {
    key: 'privacy',
    slug: LEGAL_ROOT_SLUGS.PRIVACY,
  },
  {
    key: 'dataDeletion',
    slug: LEGAL_ROOT_SLUGS.DATA_DELETION,
  },
  {
    key: 'terms',
    slug: LEGAL_ROOT_SLUGS.TERMS,
  },
  {
    key: 'credits',
    slug: LEGAL_ROOT_SLUGS.CREDITS,
  },
]

export const PRIVACY_AND_DATA_SCREEN = {
  TITLE: 'Privacy and data',
  INTRO:
    'Review how we handle your information. These documents are the same as on our public site.',
  SECTION_LEGAL: 'Policies',
  SECTION_DANGER: 'Danger zone',
  DANGER_CARD_TITLE: 'Delete your account',
  DANGER_COPY:
    'This permanently removes your account and associated data. After you confirm, you will be signed out immediately while we finish removing your data in the background.',
  DELETE_ACCOUNT: 'Delete account',
  CANCEL: 'Cancel',
  CONFIRM_INSTRUCTION: 'This cannot be undone. To confirm, type the phrase below.',
  DELETION_ALREADY_QUEUED: 'Deletion in progress',
  DELETION_ALREADY_QUEUED_MESSAGE:
    'Your account deletion is being processed. No further action is needed.',
  ACCOUNT_STATUS: 'Account status',
  ACCOUNT_NO_LONGER_ACTIVE: 'This account is no longer active.',
  COULD_NOT_REQUEST: 'Could not request deletion',
  TRY_AGAIN_LATER: 'Try again later.',
  CHECK_CONNECTION: 'Check your connection and try again.',
} as const

/** Query param for `/sign-in` after in-app deletion (sign-out is immediate). */
export const SIGN_IN_REASON_ACCOUNT_DELETED = 'account_deleted'

/** Query param when user had an active deletion job (PENDING/PROCESSING) and was signed out by the access gate. */
export const SIGN_IN_REASON_ACCOUNT_DELETION_PENDING = 'account_deletion_pending'

/** Query param when deletion job completed but session still existed — sign out and block re-entry. */
export const SIGN_IN_REASON_ACCOUNT_DELETION_COMPLETED = 'account_deletion_completed'

export const ACCOUNT_DELETED_SIGN_OUT_SNACKBAR =
  'Your account deletion has started. You have been signed out.'

export const ACCOUNT_DELETED_SIGN_OUT_SNACKBAR_TITLE = 'Signed out'

/** Sign-in banner: deletion requested, signed out (same copy as snackbar replacement). */
export const SIGN_IN_BANNER_ACCOUNT_DELETION_STARTED = ACCOUNT_DELETED_SIGN_OUT_SNACKBAR

/** Sign-in banner: deletion already running — cannot use app. */
export const SIGN_IN_BANNER_DELETION_IN_PROGRESS =
  'Your account deletion is in progress. You cannot use the app until it finishes. You have been signed out.'

/** Sign-in banner: deletion finished — account closed. */
export const SIGN_IN_BANNER_ACCOUNT_REMOVED =
  'This account has been removed. You have been signed out.'

/**
 * Sign-in banner: Postgres profile was removed but Supabase Auth user delete failed (separate step).
 * Product framing: no active Zporti account — not “job still running.”
 */
export const SIGN_IN_BANNER_ACCOUNT_DELETION_INCOMPLETE =
  'This email is no longer registered with an active Zporti account. You cannot sign in. If you deleted your account and still see this, contact support so we can finish removing your login.'
